require('../fhApp/transformResource');
require('../shared/dataTransformers/clipTransformer');
require('../shared/clipCategoryService');

'use strict';

angular.module('app.shared.singleClipService', [
  'app.transformResource',
  'app.shared.dataTransformers.clipTransformer',
  'app.shared.clipCategoryService'
])
  .constant('CLIP_EVENTS', {
    FLAGGED_AS_INAPPROPRIATE: 'flagedAsInappropriate'
  })
  .factory('app.shared.singleClipService', [
    '$rootScope',
    '$http',
    '$q',
    '$httpParamSerializerJQLike',
    'app.transformResource',
    'app.shared.dataTransformers.clipTransformer',
    'app.shared.clipCategoryService',
    'CLIP_EVENTS',
    function ($rootScope, $http, $q, $httpParamSerializerJQLike, transformResource, clipTransformer,
              clipCategoryService, CLIP_EVENTS) {
      "use strict";

      let service = {
        data: null,
        error: null,
        transformer: clipTransformer,
        clear: function () {
          service.data = null;
          service.error = null;
        },
        retrieve: function (clip_id, params) {
          if (clip_id) {
            params = $httpParamSerializerJQLike(params);

            return $http({
              method: 'GET',
              url: window.location.api('clips/' + clip_id + '?' + params),
              transformResponse: transformResource.onResponse(clipTransformer.transformToUi)
            })
              .then(function (response) {
                let data = response.data;

                service.data = null;
                service.error = null;
                if (data.error) {
                  service.error = data.error;
                } else {
                  service.load(data);
                }

                return response;
              });
          }
        },
        load: function (data) {
          service.data = data;
        },
        toggle_like: function (clip_id) {
          return $http.post(window.location.api('likes/clip/' + clip_id));
        },
        delete: function (clip_id) {
          if (typeof clip_id === 'undefined' && service.data) {
            clip_id = service.data.iclipid;
          }
          return $http.delete(window.location.api('clips/' + clip_id));
        },
        updateClip: function (clip_id, data) {
          let clip = clipTransformer.transformToApi(angular.copy(data));
          return $http.put(window.location.api('clips/' + clip_id), clip);
        },
        getHotKeys: function () {
          return $http({
            method: 'GET',
            url: window.location.api('clips_overrides'),
            transformResponse: transformResource.onResponse(clipTransformer.transformToHotKey)
          })
            .then(function (response) {
              return response;
            });
        },
        updateUserHotKey: function (hotkey) {
          return $http.post(window.location.api('clips_overrides/' + hotkey.iclipcategoryid), hotkey);
        },
        getStreamUrl: function (audio) {
          if (service.data) {
            if (!audio) {
              audio = 1;
            }

            let clip_id = service.data.iclipid;
            return $http.get(window.location.api('clips/' + clip_id + '/stream_url/' + audio))
          }
        },
        logWatched: function (clip) {
          if (!clip && service.data && service.data.iclipid) {
            clip = service.data;
          }

          if (clip) {
            return $http.post(window.location.api('clips/' + clip.iclipid + '/log_watched'))
              .then(response => {
                let data = response.data;

                if (data && data.watch_count) {
                  clip.watch_count = data.watch_count;
                }

                return response;
              });
          }
        },
        flagInappropriate: function (clipId) {
          return $http.put(window.location.api('clips/flag/inappropriate/' + clipId))
            .then((response) => {
              $rootScope.$emit(CLIP_EVENTS.FLAGGED_AS_INAPPROPRIATE, clipId);
              return response;
            });
        },
        syndicate: function (clip_id) {
          return $http.post(window.location.api('clips/' + clip_id + '/syndicate'));
        },
        toggleStarred: (clip_id) => {
          if (typeof clip_id === 'undefined') {
            clip_id = service.data ? service.data.iclipid : null;
          }

          return $http.put(window.location.api('clips_starred_clips/toggle/' + clip_id));
        },
        bulkDelete: (clip_ids) => {
          return $http.put(window.location.api('clips_bulk_delete'), {ids: clip_ids});
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/singleClipService.js